import { onFieldValueChange } from '@eastcoal/formily/exports/core'

import { SPLIT_COUNT_FIELD } from '../../constants/field'

export const dealCountEffect = () => {
  // “拆分拍模式”禁用
  onFieldValueChange(SPLIT_COUNT_FIELD, (_, form) => {
    const { wholeSale } = form.values
    const disabled = !wholeSale
    form.setFieldState('dealCount', state => {
      state.disabled = disabled
      if (disabled) state.value = undefined
    })
  })
}
